var contentInnerStyle = 'fx_e395032e_17el7vp3';
var contentStyle = 'fx_e395032e_17el7vp2';

export { contentInnerStyle, contentStyle };
//# sourceMappingURL=styles.vanilla.mjs.map
